// Site environment (dev/qa/prod...) that will appear on the main page.
export const env = 'QA2';

// AAD ClientID
export const clientId = '80e01145-4b76-4190-91f5-c5cd6905abd5';

// API host url:
export const apiHost = 'https://tkk-qa.taiwankk.com/api';

// 洗標路徑
export const labelUrl = 'https://s3-ap-northeast-1.amazonaws.com/tkk-model-template-qa/';

// 套量App host url
export const fittingappHost = 'https://fittingapp-m-qa.goodchuck.com.tw/';

// 版號
export const version = "0.26.2";


// WEBPACK FOOTER //
// ./src/config.js